import { t } from "../../hooks/useAppTranslation";
import {useEffect, useState} from "react";
import Select from "react-dropdown-select";
import clsx from 'clsx';
import CloseIcon from '@mui/icons-material/Close';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

import './SelectCustom.scss';

const SelectCustom = ({ 
  containerClassName,
  className,
  dropdownId,
  disabled,
  error,
  errorId,
  id,
  invalid,
  label,
  labelHeader,
  labelClassName,
  isMulti,
  onClear,
  parentRef,
  optionNameVisible,
  ...props
}) => {
  const [isDropDownOpened, setIsDropDownOpened] = useState(false);

  const setAttr = (querySelector, attr, attrVal, all = false) => {
    if (!parentRef?.current) return;
    let selectField;

    if (all) {
      selectField = parentRef.current.querySelectorAll(querySelector);
      selectField.forEach(field => field.setAttribute(attr, attrVal));
    } else {
      selectField = parentRef.current.querySelector(querySelector);

      if (selectField) {
        selectField.setAttribute(attr, attrVal);
      }
    }
  };

  const containerClassNameClsx = clsx(['select-container', containerClassName]);
  const selectClassNameClsx = clsx([
    'select-custom',
    invalid && 'select-custom--invalid',
    disabled && 'select-custom--disabled',
    className,
  ]);
  const labelClassNameClsx = clsx(['select-custom__label', labelHeader && 'select-custom__label--header', labelClassName]);

  useEffect(() => {
    setAttr('.react-dropdown-select', 'aria-label', `${t("g-dropdown-list")} ${label}. ${t("g-arrow-display-options")} ${isMulti ? t("g-can-select-more-options") : ''}`);
    setAttr('.react-dropdown-select-input', 'aria-haspopup', 'listbox');

    setAttr('.react-dropdown-select-dropdown', 'id', dropdownId);
    setAttr('.react-dropdown-select-dropdown', 'tabindex', 0);
    setAttr('.react-dropdown-select-dropdown', 'role', 'listbox');
    setAttr('.react-dropdown-select-input', 'id', id);
    setAttr('.react-dropdown-select-input', 'aria-activedescendant', dropdownId);
    setAttr('.react-dropdown-select-input', 'tabindex', 0);
    setAttr('.react-dropdown-select-content', 'role', 'status');

    if (isDropDownOpened) {
      setAttr('.react-dropdown-select-item', 'tabindex', 0, true);
    }

    if (isMulti) {
      setAttr('.react-dropdown-select-option-remove', 'aria-label', t("g-remove-option"), true)
    }

    if (errorId) {
      setAttr('.react-dropdown-select-input', 'aria-describedby', errorId);
    }
  }, [isDropDownOpened, errorId, isMulti, label, id, parentRef]);

  useEffect(() => {
    if (isMulti) {
      setAttr('.react-dropdown-select-option-remove', 'aria-label', t("g-remove-option"), true)
    }
  });

  useEffect(() => {
    // If optionNameVisible={true} (value is selected), show its name in input. Otherwise clear the input (<span>{option name}</span>)
    if (optionNameVisible === undefined) return;
    if (optionNameVisible?.length === 0) {
      setAttr('.react-dropdown-select-content > span', 'class', 'hidden');
    } else {
      setAttr('.react-dropdown-select-content > span', 'class', 'shown');
    }
  }, [optionNameVisible]);

  const handleDropdownClose = () => {
    setIsDropDownOpened(false);
    parentRef?.current.querySelector('.react-dropdown-select-input').focus();
  };


  const onClearRendered = ({ methods }) => (
    <button type="button" tabIndex={0} onClick={methods.clearAll} className="btn select-custom__button btn select-custom__button--close" disabled={disabled}>
      <CloseIcon fontSize="small" aria-hidden={true} />
      <span className="sr-only">{t("g-clear-field")} {label}</span>
    </button>
  );

  const renderOption = () => (
    <button type="button" onClick={() => setIsDropDownOpened(!isDropDownOpened)} className="btn select-custom__button" disabled={disabled}>
      {isDropDownOpened ? <KeyboardArrowUpIcon fontSize="small" aria-hidden={true} /> : <KeyboardArrowDownIcon fontSize="small" aria-hidden={true} />}
      <span className="sr-only">{isDropDownOpened ? t("g-collapse-list") : t("g-show-list")}</span>
    </button>
  );

  return (
    <div className={containerClassNameClsx} ref={parentRef}>
      <label htmlFor={id} className={labelClassNameClsx}>{label}</label>
      <Select
        disabled={disabled}
        className={selectClassNameClsx}
        color="#0d47a1"
        id={id}
        noDataRenderer={() => <p className="select-custom__empty" role="alert">{t("g-no-results-found")}</p>}
        dropdownHandleRenderer={renderOption}
        clearRenderer={onClearRendered}
        onDropdownOpen={() => setIsDropDownOpened(true)}
        onDropdownClose={handleDropdownClose}
        dropdownHandle={false}
        keepSelectedInList
        searchable
        handle
        clearable
        {...props}
      />
      {errorId && <p id={errorId} className="select-custom__error" role="alert">{error}</p>}
    </div>
  )
};

export default SelectCustom;
